import React from 'react'
import { createRoot } from 'react-dom/client'
import * as Sentry from '@sentry/browser'

import './style.css'

import App from './App'

const HOSTNAMES = {
  DEV: 'smarttips-dev.k8s-vs.cognito.cz',
  STAGING: 'smarttips-staging.k8s-vs.cognito.cz',
  PRODUCTION: 'smarttips.cz',
  PRODUCTION_WWW: 'www.smarttips.cz'
}

const ENVIRONMENTS = {
  DEV: 'dev',
  STAGING: 'staging',
  PRODUCTION: 'production',
  PRODUCTION_WWW: 'production'
}

const isLocal = window.location.hostname === 'localhost'
  || window.location.hostname === '127.0.0.1'
  || window.location.hostname.endsWith('.localhost')

if (!isLocal) {
  const hostnameKey = Object.keys(HOSTNAMES).find(key => HOSTNAMES[key] === window.location.hostname)
  const environment = hostnameKey ? ENVIRONMENTS[hostnameKey] : 'unknown'

  Sentry.init({
    dsn: 'https://1fcb3a6531a646e793324ceb50fed0c4@glitchtip.cognito.cz/28',
    environment,
    beforeSend (event, hint) {
      const error = hint?.originalException
      if (error?.isAxiosError && error?.response?.status < 500) {
        return null
      }
      return event
    }
  })
}

const container = document.getElementById('app')
const root = createRoot(container)

root.render(<App />)
